import React, { useEffect, useState } from "react";
import CommonTable from "../common/CommonTable";
import CommonModal from "../common/CommonModal";
import BranchForm from "../Forms/BranchForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "../Commonfunction/UserContext";
import { getData, postData } from "../Commonfunction/CommonFunction";
import { checkPermission } from "../Commonfunction/NewPermission";
import TopHeading from "../common/TopHeading";
import PermissionMessage from "../common/PermissionMessage";
import DeleteConfirmationModal from "../common/DeleteConfirmationModal";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importing toast styles
import TaxTableForm from "../Forms/TaxTableForm";
import "../../assets/style/Employees.css";
import { GoPasskeyFill } from "react-icons/go";

export default function Employees() {
  const [tableData, setTableData] = useState([]);
  const [tabData, setTabData] = useState();
  const { role, setUserAccess } = useUser();
  const [rowId, setRowId] = useState(null);
  const [permissionsData, setPermissionsData] = useState({});
  const [open, setOpen] = useState(false);
  const [permissionMessage, setPermissionMessage] = useState(false);
  const [filter, setFilter] = useState("ALL EMPLOYEES");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  //   const handleClose = () => {
  //     setShowModal(false);
  //     setRowId(null);
  //     fetchData();
  //   };
  const handleStatusToggle = async (id, newStatus) => {
    try {
      const request_url = `/api/update-employee-status/${id}`;
      const response = await postData(request_url, { is_active: newStatus });
      if (response.success) {
        fetchData();
        toast?.success(response?.message);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log("Error: ", error);
      toast.error("Failed to update status");
    }
  };
  useEffect(() => {
    if (location?.state?.filterName) {
      setFilter(location.state.filterName);
    }
    // fetchData();
  }, [location]);

  useEffect(() => {
    if (filter === "ALL EMPLOYEES") {
      // setFilter(location.state.filterName);
      fetchData();
    }
  }, [filter === "ALL EMPLOYEES"]);

  // Define columns with action column correctly structured
  const columns = [
    {
      key: "action",
      label: "Action",
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", width: "100%" }}>
          <div
            className="action-buttons"
            style={{ display: "flex", gap: "10px" }}
          >
            <button
              className="edit-btn"
              onClick={() =>
                fetchDataUserAccess(
                  "edit",
                  false,
                  params,
                  `/edit-employee/${params?.id}`
                )
              }
            >
              <TbEdit size={22} />
            </button>
            <button
              className="delete-btn"
              onClick={() => fetchDataUserAccess("delete", true, params, "")}
            >
              <RiDeleteBin6Line size={22} />
            </button>
            <button
              className="action-button download"
              onClick={() =>
                fetchDataUserAccess(
                  "permission",
                  false,
                  params,
                  `/role/employee/permission/${params?.id}`
                )
              }
             
            >
              <GoPasskeyFill size={22}  />
            </button>
          </div>
        </div>
      ),
    },
    {
      key: "status",
      label: "Status",
      renderCell: (params) => (
        <div className="status-toggle-container">
          <div className="modern-switch modern-switch--small">
            <input
              type="checkbox"
              className="modern-switch__input"
              id={`status-switch-${params.id}`}
              defaultChecked={params?.is_active === 1}
              onChange={(event) =>
                handleStatusToggle(params.id, event.target.checked ? 1 : 0)
              }
            />
            <label
              className="modern-switch__label"
              htmlFor={`status-switch-${params.id}`}
            >
              <span className="modern-switch__button"></span>
              <span className="modern-switch__text">
                {params?.row?.is_active === 1 ? "Active" : ""}
              </span>
            </label>
          </div>
        </div>
      ),
    },
    { key: "employee_name", label: "Name", sortable: true },
    { key: "email", label: "Email", sortable: true },
    { key: "mobile_no", label: "Mobile Number", sortable: true },
    { key: "gender", label: "Gender", sortable: true },
    { key: "employee_type_name", label: "Employee Type", sortable: true },
    
  ];

  const fetchDataUserAccess = async (method, showPopup, params, goToLink) => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
        if (checkPermission(role, method, result.permission)) {
          if (showPopup) {
            if (method === "delete") {
              setOpen(true);
              setRowId(params.id);
            } else {
              setRowId(params.id);
            }
          } else if (goToLink) {
            navigate(goToLink);
          }
        } else {
          setPermissionMessage(true);
        }
      }
    } catch (error) {
      console.error("Error fetching user access:", error);
    }
  };

  const fetchData = async () => {
    setTableData([]);
    try {
      const result = await getData("/api/all-employees");
      if (result.success) {
        if (!checkPermission("Employees", "view", result.permission)) {
          setPermissionMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 2000);
        }
        setTableData(result.data || []);
        setPermissionsData(result?.permission || {});
      } else {
        console.error("Error===>", result.message);
        // setPermissionsData(result?.permission || {});
      }
    } catch (error) {
      // if (!checkPermission("Employees", "view", error.permission)) {
      //     setPermissionMessage(true);
      //     setTimeout(() => {
      //         navigate("/dashboard");
      //     }, 2000);
      // }
      console.error("Error===>2", error);
    }
  };

  const indexedRows =
    Array.isArray(tableData) && tableData.length > 0
      ? tableData.map((data, index) => ({
          index: index + 1,
          id: data.id,
          employee_name: data?.employee_name,
          email: data?.email,
          mobile_no: data?.mobile_no,
          gender: data?.gender,
          employee_type_name: data?.employee_type_name,
          is_active: data?.is_active,
        }))
      : [];

  const groupedData = tableData.reduce((acc, employee) => {
    const { employee_type_name } = employee;
    if (!acc[employee_type_name]) {
      acc[employee_type_name] = [];
    }
    acc[employee_type_name].push(employee);
    return acc;
  }, {});

  const filteredRows =
    filter === "ALL EMPLOYEES"
      ? indexedRows.filter((row) => row?.is_active == 1)
      : indexedRows.filter((row) => row?.employee_type_name === filter);

  const inactiveRows =
    filter === "INACTIVE" && indexedRows.filter((row) => row?.is_active == 0);

  console.log("test===>", inactiveRows);

  return (
    <div className="usa-prose">
      <TopHeading
        heading="Employees"
        path={"/add-employee"}
        isHideBtn={true}
        csvFileUpload={false}
        csvName="Add Employee By CSV"
      />

      <div className="tf-container">
        <div className="tf-wrapper">
          <div className="tf-title-area">
            {/* <span className="tf-title">Filter Employees</span>
            <div className="tf-title-accent"></div> */}
            <div className="tf-buttons">
              <div
                className={`tf-button ${
                  filter === "ALL EMPLOYEES"
                    ? "btn-primary"
                    : "btn-primary-inactive"
                }`}
                onClick={() => setFilter("ALL EMPLOYEES")}
              >
                <span className="tf-button-text">ALL EMPLOYEES</span>
                <svg
                  className="tf-button-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 12H16M12 8V16"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              <div
                className={`tf-button ${
                  filter === "INACTIVE" ? "btn-primary" : "btn-primary-inactive"
                }`}
                onClick={() => {
                  setTabData("INACTIVE");
                  setFilter("INACTIVE");
                }}
              >
                <span className="tf-button-text">INACTIVE</span>
                <svg
                  className="tf-button-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18 6L6 18M6 6L18 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>

              {Object.keys(groupedData).map((group) => (
                <button
                  key={group}
                  className={`tf-button ${
                    filter === group ? "btn-primary" : "btn-primary-inactive"
                  }`}
                  onClick={() => setFilter(group)}
                >
                  <span className="tf-button-text">{group}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <CommonTable
        data={filter === "INACTIVE" ? inactiveRows : filteredRows}
        columns={columns}
        // data={indexedRows || []}
      />
      {open && (
        <DeleteConfirmationModal
          open={true}
          handleClose={() => setOpen(false)}
          request_url={`/api/delete-county/${rowId}`}
          getApi={fetchData}
        />
      )}

      {permissionMessage && (
        <PermissionMessage
          open={true}
          handleClose={() => {
            setPermissionMessage(false);
          }}
        />
      )}
    </div>
  );
}
